const SendEmailStatus = Object.freeze({
    SUCCESSFUL_DELIVERY: { value: 'successful_delivery', text: 'Successful delivery' },
    //DELIVERY_ERROR: { value: 'delivery_error', text: 'Delivered error' },
    PERMANENT_ERROR: { value: 'permanent_error', text: 'Permanent error' },
    TEMPORARY_ERROR: { value: 'temporary_error', text: 'Temporary error' },
    UNKNOWN_ERROR: { value: 'unknown_error', text: 'Unknown error' },
});
export default SendEmailStatus;
